"use strict";

const MonitoringLocationGeoServerLayer = function () {
  const layerName = "monitoringLocation";
  const layerKey = "monitoringLocationLayer";

  var createMarkerFunction = function (feature, latlng) {
    return DryWeatherIcon.getDryWeatherMarker(
      latlng,
      feature.properties,
      MapFunctions.resizeIconsOnZoom(
        Tree.get("zoomLevel"),
        40,
        20,
        "icon-text-large",
        "icon-text-medium",
      ),
    );
  };

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    const layer = new GeoServerMapLayer(layerName, layerKey, createMarkerFunction);
    GeoServerLayerFunctions.setLayerInstanceByMapId(layerName, mapId, layer);

    layer.loadToggledListenerForMap(map, mapLayers, mapId);
    layer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };

  var loadLayer = function (mapId = "main") {
    GeoServerLayerFunctions.loadLayerByMapId(layerName, mapId);
  };

  var invalidateLayerData = function (loadingScreen = true) {
    GeoServerLayerFunctions.invalidateLayerDataForMainMap(layerName, loadingScreen);
  };

  var getLayerData = async function (onlineFiltering = false, loadingScreen = true) {
    const data = await ApiCalls.getMonitoringLocations();
    return organizeLayerData(data);
  };

  var organizeLayerData = function (layerData) {
    return layerData.map(function (data) {
      return getOrganizedProperties(data);
    });
  };

  var getOrganizedProperties = function (data) {
    return {
      id: CompositeAssetId.build(data.asset_type, data.id),
      assetDisplayType: ToolSettings.getSetting(
        "constants",
        "assetDisplayNames",
        data.asset_type_display_key,
      ),
      geometry: data.geom,
      name: data.name,
      displayAddress: Misc.getFullMailingAddress(data.address, data.city, data.state, data.zip),
      cof: data.cof_final_text,
      isHighPriority: data.is_high_priority,
      isMonitoringLocation: data.monitoring_location_id !== null,
      dryWeatherCondition: data.dry_weather_condition,
      isDue: data.todo_id_monitoring_location !== null ? true : false,
      rotationAzimuth: data.rotation_azimuth,
      isFcs: data.is_fcs,
      catchmentName: data.catchment_name,
      drainsToRw: data.drains_to_rw,
      drainsToC: data.drains_to_c,
      flowCondition: data.flow_condition,
      collectSamples: data.collect_samples,
      illicitDischarge: data.illicit_discharge,
      waterQualityExceedances: data.water_quality_exceedances,
      iddeScreeningDate: data.idde_screening_date,
      groupId: data.group_id,
      monitoringLocationId: data.monitoring_location_id,
      ...GeoServerLayerFunctions.prepareToDoData(data, {
        monitoring_location: "routineScreeningDryWeather",
        monitoring_location_re_screening: "reScreeningDryWeather",
      }),
    };
  };

  return {
    getLayerData,
    organizeLayerData,
    getOrganizedProperties,
    loadLayerListenersForMap,
    loadLayer,
    invalidateLayerData,
  };
};

module.exports = MonitoringLocationGeoServerLayer();

const ApiCalls = require("../apiCalls");
const CompositeAssetId = require("../general/compositeAssetId");
const GeoServerLayerFunctions = require("../mapFunctions/geoServerLayerFunctions");
const GeoServerMapLayer = require("../mapFunctions/geoServerMapLayer");
const DryWeatherIcon = require("./dryWeatherIcon");
const MapFunctions = require("../mapFunctions/mapFunctions");
const Tree = require("../tree");
const ToolSettings = require("../settings/toolSettings");
const Misc = require("../misc");
